import Box from '@amzn/meridian/box/box';
import React from 'react';
import Alert from '@amzn/meridian/alert/alert';
import { FormattedMessage } from 'react-intl';
import Row from '@amzn/meridian/row/row';
import Loader from '@amzn/meridian/loader/loader';
import { TagType } from '@amzn/meridian/tag/tag';

export interface TmCoachingStats {
  userId: string;
  userAlias: string;
  userFullName: string;
  weeklyCoachingsCompleted: number;
  monthlyCoachingsCompleted: number;
  expectedWeeklyCoachings: number;
  expectedMonthlyCoachings: number;
  directReportCount: number;
}

export type CoachingTableItemStatus = {
  tagType: TagType;
  tagText: string;
  id: string;
};

export const errorMessageBox = (
  <Box height='550px' width='fill' spacingInset='300'>
    <Alert type='error'>
      <FormattedMessage
        id='cs_perfportal_error_refresh_page'
        defaultMessage='Something went wrong. Please try refreshing the page. 
                If the problem persists, please submit a SIM ticket for us to troubleshoot.'
      />
    </Alert>
  </Box>
);

export const tableLoader = (
  <Row type='outline' width='100%' alignmentHorizontal='center' height='600px'>
    <Loader />
  </Row>
);

export enum MonthSelection {
  THIS_MONTH = 'CURRENT_MONTH',
  LAST_MONTH = 'LAST_MONTH',
}

export enum TmTabSelection {
  COACHINGS = 'tab-coachings',
  CONTACT_REVIEWS = 'tab-contact-reviews',
}

export enum CoachingsTableSortColumn {
  DATE = 'date',
  ASSOCIATE_NAME = 'associateName',
  COACHING_STATUS = 'coachingStatus',
}

export enum ContactReviewsTableSortColumn {
  DATE = 'date',
  ASSOCIATE_NAME = 'associateName',
}

export enum TmTableSortColumn {
  ASSOCIATE_NAME = 'associateName',
  STATUS = 'status',
  MONTHLY_COACHINGS_COMPLETED = 'monthlyCoachingsCompleted',
  WEEKLY_COACHINGS_COMPLETED = 'weeklyCoachingsCompleted',
}
